import React, { Component } from 'react'
import { connect } from 'react-redux'
import Modal from 'react-modal'
import { Grid, Row, Col } from 'react-bootstrap'
import { getSubModalStyles } from '../../common/utils'
import MessageGroupCustom from './MessageGroupCustom'
import { createOrUpdateUsersGroup, removeMessageGroups, getMessageGroups } from './actions'
import ChooseLockUser from '../../common/components/ChooseLockUser'
import { swalError } from '../../common/components/Swaler'

class CustomView extends Component {
    constructor(props) {
        super(props)
    }

    state = { showChooseLockUserModal: false, messageGroups: [] }

    replaceMessageGroup = (group) => {
        let messageGroups = []
        if (!this.state.messageGroups.length) {
            messageGroups.push(group)
        } else if (!this.state.messageGroups.some(g => g._id === group._id)) {
            messageGroups = this.state.messageGroups.concat(group)
        } else {
            messageGroups = this.state.messageGroups.map(g => {
                if (g._id === group._id) return group

                return g
            })
        }

        this.setState({ messageGroups })
    }

    componentWillMount() {
        getMessageGroups(this.props.lock._id).then(t => {
            this.setState({ messageGroups: t.messageGroups.filter(g => g.groupType === "custom") })
        })
    }

    lockUsersChoosen = ({ groupName, customerIds, groupId = null }) => {
        if (!this.state.groupName || this.state.groupName.length < 1) {
            return swalError("Gruppnamn", "Du måste fylla i ett namn på gruppen!")
        }

        this.setState({ showChooseLockUserModal: false, showEditLockUserModal: false })

        if (!customerIds || !customerIds.length) return

        const { lock } = this.props
        createOrUpdateUsersGroup(lock._id, customerIds, { groupType: 'custom', groupName, _id: groupId }).then(t => {
            this.replaceMessageGroup(t)
        })
    }

    removeCustomGroups = (groupIds) => {
        removeMessageGroups(groupIds).then(t => {
            this.setState({
                messageGroups: this.state.messageGroups.filter(group => !groupIds.includes(group._id))
            })
        })
    }

    closeChooseModal = () => {
        this.setState({ showChooseLockUserModal: false })
    }

    change = (key, val) => {
        this.setState({ [key]: val })
    }

    getInputComponent = () => {
        return (
            <div>
                <input
                    type="text"
                    value={this.state.groupName}
                    onChange={(e) => this.change('groupName', e.target.value)}
                    placeholder="Fyll i namn på gruppen"
                    style={{ border: 'none', borderBottom: '3px solid #246d6e', width: '50%', textAlign: 'center', fontSize: 14, marginLeft: '25%' }} />

                <br />
                <br />

                <ChooseLockUser lock={this.props.lock} defaultCheckedCustomerIds={this.state.customerIds} finished={() => this.lockUsersChoosen(this.state)} change={this.change} />
            </div>
        )
    }

    editGroup = (group) => {
        const customerIds = group.users.map(u => u.customer)
        this.setState({ showEditLockUserModal: true, customerIds, groupName: group.groupName, groupId: group._id })
    }

    render() {
        const { messageGroups } = this.state

        return (
            <div style={this.props.style}>
                <Modal
                    ariaHideApp={false}
                    isOpen={this.state.showChooseLockUserModal}
                    onRequestClose={this.closeChooseModal}
                    onAfterClose={() => this.setState({ customerIds: null, groupId: null, groupName: '' })}
                    style={getSubModalStyles()}>

                    <div className="qCloseButton" onClick={() => this.setState({ showChooseLockUserModal: false })}>Stäng</div>

                    <br />
                    <br />

                    {this.getInputComponent()}
                </Modal>

                <Modal
                    ariaHideApp={false}
                    isOpen={this.state.showEditLockUserModal}
                    onRequestClose={() => this.setState({ showEditLockUserModal: false })}
                    onAfterClose={() => this.setState({ customerIds: null, groupId: null, groupName: '' })}
                    style={getSubModalStyles()}>

                    <div className="qCloseButton" onClick={() => this.setState({ showEditLockUserModal: false })}>Stäng</div>

                    <br />
                    <br />

                    {this.getInputComponent()}
                </Modal>


                <Grid style={{ maxWidth: '100%' }}>
                    <Row>
                        <Col lg={12}>
                            <span></span>
                        </Col>
                    </Row>

                    <br />

                    <Row>
                        <Col lg={3}>
                            <span style={{ fontSize: 20 }}>Egen grupp</span>
                        </Col>
                        <Col lg={9} style={{ textAlign: 'left' }}>
                            <span className="qLink" onClick={() => this.setState({ showChooseLockUserModal: true })}>+ Skapa grupp</span>
                        </Col>
                    </Row>

                    <br />

                    <Row>
                        <Col lg={12}>
                            {!messageGroups ? 'Laddar' :
                                messageGroups.map((group, i) => {
                                    return (
                                        <MessageGroupCustom key={i} editGroup={this.editGroup} removeCustomGroups={this.removeCustomGroups} group={group} groupCustomId={group._id} />
                                    )
                                })
                            }
                        </Col>
                    </Row>
                </Grid>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        keyedCustomers: state.collectionData.keyedCustomers,
        messageGroups: state.collectionData.messageGroups
    }
}

const mapDispatch = (dispatch) => {
    return {}
}

export default connect(mapStateToProps, mapDispatch)(CustomView)